<script setup lang="ts">
import { ref, computed, onBeforeMount, watch } from 'vue'
import { baseUrl } from '@/core'
import { useRoute, useRouter } from 'vue-router'
import { appServices } from '@/modules/app'
import VideoPlayer from '@/modules/app/components/base/VideoPlayer.vue'

import { useIdleTimeout } from '@/modules/app/composables/useIdleTimeout'

const router = useRouter()
const route = useRoute()

// Define Props ----------------------------------
const props = defineProps<{
  lang: string
}>()

// State -----------------------------------------
const { lang } = props
const dataId = ref(route.params.id)
const video = ref<InstanceType<typeof VideoPlayer>>()

// Getters ---------------------------------------

// Methods ---------------------------------------
function backToMain() {
  appServices.nextBackgroundMusic($config.backgroundMusicAutoplay)
  router.push({ path: '/' })
}

// Events ----------------------------------------
onBeforeMount(() => {
  console.log('onBeforeMount', 'pauseBackgroundMusic()')
  appServices.pauseBackgroundMusic()
})

function onVideoPlay() {
  console.log('onVideoPlay')
  mainIdleTimeout.stop()
  videoIdleTimeout.stop()
}

function onVideoPause() {
  console.log('onVideoPause')
  videoIdleTimeout.start()
}

function onVideoEnded() {
  console.log('onVideoEnded')
  mainIdleTimeout.start()
  videoIdleTimeout.stop()
}

// Main Setup ------------------------------------

const mainIdleTimeout = useIdleTimeout('home', $config.discoveryIdleTimeoutToMainSeconds * 1000)
const videoIdleTimeout = useIdleTimeout('video', $config.discoveryIdleTimeoutToPlaySeconds * 1000)

mainIdleTimeout.onIdleTimeout(() => {
  backToMain()
})

videoIdleTimeout.onIdleTimeout(() => {
  video.value?.play()
})

// const videoTimeout = useIdleTimeout('video', 2000)

// -----------------------------------------------
</script>

<template>
  <div :class="['discovery-content', `lang-${lang}`]">
    <img class="logo-small" :src="baseUrl(`/images/discovery/${lang}/logo-small.png`)" />
    <img class="subject" :src="baseUrl(`/images/discovery/${lang}/subject.png`)" />
    <div class="desc scrollbar">
      <img class="detail" :src="baseUrl(`/images/discovery/${lang}/desc-detail.png`)" />
    </div>
    <img class="back-to-main" :src="baseUrl(`/images/discovery/${lang}/back-to-main.gif`)" @click="backToMain" />
    <VideoPlayer
      ref="video"
      :src="baseUrl(`/videos/video-discovery.mp4`)"
      :autoplay="true"
      @ended="onVideoEnded"
      @pause="onVideoPause"
      @play="onVideoPlay"
    />
  </div>
</template>

<style scoped>
/* ------------------------ */
/* ------------------------ */
.discovery-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
/* ------------------------ */
.back-to-main {
  position: absolute;
  left: 36px;
  top: 967px;
  cursor: pointer;
}

.logo-small {
  position: absolute;
  left: 0;
  top: 0;
}

.subject {
  position: absolute;
  left: 847px;
  top: 128px;
}

.desc {
  position: absolute;
  left: 38px;
  top: 240px;
  width: 585px;
  height: 700px;
  overflow: auto;
  text-align: center;
}

.desc .detail {
  position: relative;
  margin: 0 auto;
}

.lang-en .desc {
  top: 243px;
  height: 685px;
}

:deep(.video-player) {
  left: 728px;
  top: 215px;
}

:deep(.video-player .controls-bg) {
  display: none;
}

:deep(.video-player .btn-replay) {
  top: 645px;
}

:deep(.video-player .btn-play) {
  top: 645px;
}

:deep(.video-player .btn-pause) {
  top: 645px;
}
/* ------------------------ */

/* ------------------------ */
</style>
